"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Composer", {
  enumerable: true,
  get: function get() {
    return _Composer.default;
  }
});
Object.defineProperty(exports, "Context", {
  enumerable: true,
  get: function get() {
    return _Context.default;
  }
});
Object.defineProperty(exports, "createBasicStyleSet", {
  enumerable: true,
  get: function get() {
    return _createBasicStyleSet.default;
  }
});
Object.defineProperty(exports, "Dots", {
  enumerable: true,
  get: function get() {
    return _Dots.default;
  }
});
Object.defineProperty(exports, "FilmStrip", {
  enumerable: true,
  get: function get() {
    return _FilmStrip.default;
  }
});
Object.defineProperty(exports, "Flipper", {
  enumerable: true,
  get: function get() {
    return _Flipper.default;
  }
});
Object.defineProperty(exports, "ScrollBar", {
  enumerable: true,
  get: function get() {
    return _ScrollBar.default;
  }
});
exports.default = void 0;

var _BasicFilm = _interopRequireDefault(require("./BasicFilm"));

var _Composer = _interopRequireDefault(require("./Composer"));

var _Context = _interopRequireDefault(require("./Context"));

var _createBasicStyleSet = _interopRequireDefault(require("./createBasicStyleSet"));

var _Dots = _interopRequireDefault(require("./Dots"));

var _FilmStrip = _interopRequireDefault(require("./FilmStrip"));

var _Flipper = _interopRequireDefault(require("./Flipper"));

var _ScrollBar = _interopRequireDefault(require("./ScrollBar"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = _BasicFilm.default;
exports.default = _default;

if (typeof document !== 'undefined' && document.head) {
  var meta = document.createElement('meta');
  meta.setAttribute('name', 'react-film');
  meta.setAttribute('content', "version=".concat("2.0.2"));
  document.head.appendChild(meta);
}